<lib-snackbar-layout [layout]="data.Layout">
    <ng-container message>
        {{ data.Data }}
    </ng-container>
    <ng-container actions>
        @if (data.ActionButtonText) {
            <lib-button
                [kind]="ButtonKind.Link"
                qaTag="action-closable-snackbar-action-button"
                (clicked)="OnAction()">
                <ng-container label>{{ data.ActionButtonText }}</ng-container>
            </lib-button>
        }
    </ng-container>

    <ng-container close>
        @if (data.IsClosable) {
            <lib-icon-button
                [kind]="ButtonKind.NeutralTertiary"
                [icon]="Icon.Common.Close"
                [size]="ButtonSize.Medium"
                qaTag="action-closable-snackbar-close-icon"
                (clicked)="Dismiss()"></lib-icon-button>
        }
    </ng-container>
</lib-snackbar-layout>
